import { render, staticRenderFns } from "./NormalSearchNav212.vue?vue&type=template&id=4c87e77a&scoped=true&"
import script from "./NormalSearchNav212.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav212.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c87e77a",
  null
  
)

export default component.exports